

export const getDates = (startDate, endDate) => {
  for(var arr=[],dt=new Date(startDate); dt<=new Date(endDate); dt.setDate(dt.getDate()+1)){
    arr.push(new Date(dt));
}
return arr;
}